import React from 'react';
import useFieldHelper from '../fieldHelper';
import { FieldLayoutProps, FieldProps } from '../types';

import { useUiTheme } from 'framework/uiTheme';

export type EmailFieldLayoutType = ReactComponent<FieldLayoutProps<Nullable<string>>>;

const EmailField = (props: FieldProps) => {
  const { getValue, getLabel } = useFieldHelper(props);
  const { EmailFieldLayout } = useUiTheme<EmailFieldLayoutType>();
  const { className } = props;

  return <EmailFieldLayout className={className} value={getValue()} label={getLabel()} />;
};

export default EmailField;
